import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Menu from "./components/Menu";
import Gallery from "./components/Gallery";
import Differentials from "./components/Differentials";
import Testimonials from "./components/Testimonials";
import HowItWorks from "./components/HowItWorks";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import Preloader from "./components/Preloader";
import ScrollToTop from "./components/ScrollToTop";
import CartDrawer from "./components/CartDrawer";
import { CartProvider } from "./lib/CartContext";

function App() {
  return (
    <CartProvider>
      <div className="App sn-grain" data-testid="app-root">
        <Preloader />
        <Navbar />
        <CartDrawer />
        <main>
          <Hero />
          <About />
          <Menu />
          <Gallery />
          <Differentials />
          <Testimonials />
          <HowItWorks />
          <FAQ />
          <FinalCTA />
        </main>
        <Footer />
        <FloatingWhatsApp />
        <ScrollToTop />
      </div>
    </CartProvider>
  );
}

export default App;
